import { get } from 'infras/rest_client';
import { ViewerItem } from 'presentations/api/schema/user';
import { apiPath } from 'presentations/routes/path';
import { setDimension, setGroup, setUserId } from '../analytics';

export const fetchSession = async () => {
  const result = await get(apiPath('/v1/session/fetch'));
  if (!result.isSuccess) {
    return { data: null, status: result.status };
  }
  return { data: result.data, status: result.status };
};

export const setTracking = async (viewer: ViewerItem) => {
  setDimension('plan', viewer.planId);
  setUserId(viewer.uid);
  if (viewer && viewer.team) {
    setGroup('teamId', viewer.team.uid);
    setGroup('teamUserRole', String(viewer.role));
    setGroup('planId', String(viewer.planId));
  }
};

export const authorize = async () => {
  const result = await fetchSession();
  const viewer: ViewerItem | null = result.data;
  if (viewer) {
    setTracking(viewer);
  }
  return viewer;
};
